import React from 'react';
import { Link } from 'react-router-dom';

import { useProfile } from '~/hooks/profile';
import * as S from './styles';

export default function Posts() {
    const {
      dataProfile,
      profileComplete,
    } = useProfile();

  return (
    <S.DivPosts>
      <div className="center">
        <h1>Registre sua música por R$ 19,90</h1>

        {
          dataProfile?.wallet?.creditUsed > 0 && profileComplete ? (
            <Link to="/dashboard/registrar-musica">Registrar música</Link>
          ) : (
            <Link to="/dashboard/adicionar-creditos/planos">Adicionar créditos</Link>
          )
        }
      </div>
    </S.DivPosts>
  );
}
